import React, { useState } from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import BuilderRightSideBar from "../../../../Layouts/BuilderRightSideBar";
import EditStateChangeLogic from "./EditStateChangeLogic";

const StateOrActivityChangeLogic = ({ logic, setLogic, selectionObj, type }) => {
  const [isStateChangeLogicOpen, setIsStateChangeLogicOpen] = useState(true);
  const [isEditbarOpen, setIsEditbarOpen] = useState(false);
  const IDKey = type === "state" ? "state_id" : "activity_id";

  const addStateChangeLogic = (e) => {
    e.stopPropagation();
    const array = [...logic, { [IDKey]: "", condition: "true" }];
    setLogic(array);
    // setStateChangeLogic([...stateChangeLogic, { state_id: "", condition: "" }]);
    setIsEditbarOpen(logic.length);
  };

  const changeLogic = (key, value, index = isEditbarOpen) => {
    const array = [...logic];
    array[index][key] = value;
    setLogic(array);
  };

  const deleteStateChangeLogic = (index) => {
    const array = [...logic];
    const newArray = array.filter((_, i) => i !== index);
    setLogic(newArray);
  };

  const toggleStateChangeLogic = () => {
    setIsStateChangeLogicOpen((prevState) => !prevState);
  };

  let heading = "State Change Logic";
  if (IDKey === "activity_id") {
    heading = "Next Activity Logic";
  }

  const resetsm = () => {
    // const b = logic[isEditbarOpen]
    if (logic[isEditbarOpen][IDKey] === "") {
      setLogic(logic.filter((_, index) => index !== isEditbarOpen));
    }
    setIsEditbarOpen(false);
  };
  console.log("logic", logic);
  function getNameFromSelectedObj(selectedObj, logicItem, idKey = "state_id") {
    const match = selectedObj.find((item) => item.id === logicItem[idKey]);
    return match?.name;
  }

  return (
    <div className={logic.length === 0 ? "activity_select_top_block empty-state" : "activity_select_top_block"}>
      <div className="post_activity_top" onClick={toggleStateChangeLogic}>
        <div
          className="section_sub_heading"
          style={{ marginBottom: "0px", textTransform: "capitalize", display: "flex", gap: "8px" }}
        >
          {heading}
          {/* <InfoTooltip documentKey={IDKey === "activity_id" ? "next_activity_logic" : "state_change_logic"} /> */}
        </div>
        <MaterialIcon name="add" className="builder_action_btn_new add" onClick={addStateChangeLogic} />
      </div>

      {isStateChangeLogicOpen && (
        <div className="state_changeLogic_container">
          {logic?.map(
            (logic, index) =>
              logic[IDKey] && (
                <div className="state_changeLogic_inputs" key={index}>
                  <div className="icons">
                    <ButtonActionIcon type="edit" onClick={() => setIsEditbarOpen(index)} />
                    <ButtonActionIcon type="delete" onClick={() => deleteStateChangeLogic(index)} />
                  </div>
                  <div>
                    <label className="builder_label font_weight_normal" style={{ color: "var(--builder-light-text)" }}>
                      {type} :{" "}
                    </label>
                    {/*{selectionObj[logic[IDKey]] && (*/}
                    {/*  <label className="builder_label">{selectionObj[logic[IDKey]]?.name}</label>*/}
                    {/*)}*/}
                    {selectionObj && (IDKey === "state_id" || IDKey === "activity_id") && (
                      <label className="builder_label font_size_small">
                        {getNameFromSelectedObj(selectionObj, logic, IDKey)}
                      </label>
                    )}
                  </div>
                  <div>
                    <label className="builder_label font_weight_normal" style={{ color: "var(--builder-light-text)" }}>
                      Logic :{" "}
                    </label>
                    <label className="builder_label font_size_small" style={{ textTransform: "none" }}>
                      {logic.condition}
                    </label>
                  </div>
                </div>
              )
          )}
        </div>
      )}
      <BuilderRightSideBar
        isOpen={isEditbarOpen === 0 || isEditbarOpen}
        heading="State Change Logic"
        onClose={() => resetsm()}
      >
        <EditStateChangeLogic
          logic={logic[isEditbarOpen]}
          selectionObj={selectionObj}
          changeLogic={changeLogic}
          setIsOpen={setIsEditbarOpen}
          type={type}
        />
      </BuilderRightSideBar>
    </div>
  );
};

export default StateOrActivityChangeLogic;
